import { render, staticRenderFns } from "./SimpleDataTable.vue?vue&type=template&id=571acc6e"
import script from "./SimpleDataTable.vue?vue&type=script&lang=js"
export * from "./SimpleDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports